import * as t from 'io-ts'
import { Lens } from 'monocle-ts'

export const Trend = t.union([t.literal('Unknown'), t.literal('Yea'), t.literal('Nay')])
export type Trend = t.TypeOf<typeof Trend>

export interface TrendMatcher<T> {
  Unknown: T
  Yea: T
  Nay: T
}

export const caseTrend =
  <T>(m: TrendMatcher<T>) =>
  (trend: Trend): T =>
    m[trend]

/**
 * TTrend is Trend with the (optional) 'at' timestamp.
 */
export const TTrend = t.type({
  at: t.union([t.null, t.string]),
  trend: Trend,
})
export type TTrend = t.TypeOf<typeof TTrend>

export const emptyTTrend: TTrend = {
  at: null,
  trend: 'Unknown',
}

export const _ttrendAt = Lens.fromProp<TTrend>()('at')
export const _ttrendTrend = Lens.fromProp<TTrend>()('trend')
